<app-drawer-layout
  [title]="drawerTitle()"
  [state]="categoryPageQuery.data() ? 'ready' : categoryPageQuery.isError() ? 'error' : 'loading'"
>
  @if (balance(); as balance) {
    <app-drawer-stat drawerTrailing [amount]="balance" label="Balance" />
  }
  @if (chartData(); as chartData) {
    <div class="mx-auto flex w-full max-w-reading flex-col gap-6">
      <doughnut-chart
        class="chart block"
        type="doughnut"
        [width]="200"
        [height]="200"
        [title]="'Spending Breakdown'"
        emptyTitle="No spending data for this month"
        [data]="chartData.actual"
      />
      <doughnut-chart
        class="chart block"
        type="doughnut"
        [width]="200"
        [height]="200"
        [title]="'Budget Breakdown'"
        [data]="chartData.expected"
        emptyTitle="No budget data to show"
      />
    </div>
  }
</app-drawer-layout>
